export const SET_ALL_PARTICIPANTS = "Setzt die Teilnehmer im Store";
export const SET_CURRENT_PARTICIPANT =
  "Setzt den aktuellen Teilnehmer im Store";
export const SET_FILTER = "Setzt die filter für die Teilnehmer im Store";
